import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config/config.service';
import { ICustomerAppsConfig } from '../config/config.module';
import { UserService } from '../user/user.service';
import { distinctUntilChanged, switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { BaseUser } from '../user/models/user';

@Injectable({
  providedIn: 'root',
})
export class LanguagePreferenceSyncService {
  constructor(
    @Inject(LOCALE_ID) private localeId: string,
    private http: HttpClient,
    private configService: ConfigService<ICustomerAppsConfig>,
    private userService: UserService<BaseUser>,
  ) {
    this.userService.mainUser$
      .pipe(
        distinctUntilChanged((a, b) => a?.id === b?.id),
        switchMap((user) => {
          if (user && user.language !== this.localeId) {
            return this.http.put(`${this.configService.config.apiUrl}/preferences/language`, { language: this.localeId });
          }
          return EMPTY;
        }),
      )
      .subscribe({
        error: (err) => console.error('Failed to sync language preference', err),
      });
  }
}
